import { enhancedApi } from './generated/matterCmsUpdatesService';

export const matterCmsUpdatesApiClient = enhancedApi.enhanceEndpoints({});

export * from './generated/matterCmsUpdatesService';
